export default [

     {
          path: '/national-risk-threat',
          name: 'NationalRiskThreat',
          component: () => import("@/views/Page/NationalRiskThreat/NationalRiskThreat.vue"),
          meta: {
               title: 'National Risk Threat',
          },
     }
];